import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import { FiPlus, FiMinus, FiHelpCircle } from "react-icons/fi";
import "./Faq.css";

const faqData = [
  {
    question:
      "What is music distribution, and why is it important for independent artists?",
    answer:
      "Music distribution involves getting your music onto streaming platforms worldwide. FT Tunes helps independent artists expand their reach, grow audiences, and manage royalties efficiently."
  },
  {
    question: "How does FT Tunes distribution service work?",
    answer:
      "FT Tunes delivers your music to Spotify, Apple Music, Amazon Music, YouTube Music and more while providing analytics, royalty tracking and promotional tools."
  },
  {
    question: "How can I increase my music visibility?",
    answer:
      "We provide smart links, playlist pitching, YouTube monetization, and promotional campaigns to boost your exposure."
  },
  {
    question: "Can I distribute music worldwide?",
    answer:
      "Yes. FT Tunes offers global distribution allowing artists to reach listeners across all major territories."
  }
];
const Faq = () => {
  const [active, setActive] = useState(null);

  return (
    <section className="faq-section-premium">
      <Container>
        <Row className="gy-5">
          {/* LEFT SIDE: Content */}
          <Col lg={5}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="faq-content-left"
            >
              <div className="faq-badge-classic">
                <FiHelpCircle className="me-2" />
                HELP CENTER
              </div>
              <h2 className="faq-main-title">
                Frequently <br />
                Asked <span className="text-purple-gradient">Questions</span>
              </h2>
              <p className="faq-subtitle">
                Got questions? We've got answers. Explore our comprehensive
                guide to music distribution, royalties, and how FT Tunes helps
                you grow.
              </p>

             
            </motion.div>
          </Col>

          {/* RIGHT SIDE: Accordion */}
          <Col lg={7}>
            <div className="faq-accordion-container">
              {faqData.map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className={`faq-item-premium ${active === index ? "active" : ""}`}
                >
                  <div
                    className="faq-question-trigger"
                    onClick={() => setActive(active === index ? null : index)}
                  >
                    <span className="faq-q-text">{faq.question}</span>
                    <div className="faq-icon-wrapper">
                      {active === index ? <FiMinus /> : <FiPlus />}
                    </div>
                  </div>

                  <AnimatePresence>
                    {active === index && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="faq-answer-wrapper"
                      >
                        <div className="faq-answer-content">{faq.answer}</div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Faq;
